import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet-async'

import { getQueryParamsFromHash, parsePermittedQueryParams } from '@domain-group/javascript-utils'

import { Box, Button, Columns } from '@domain-group/suit-theme'

import PageHeader from '@components/PageHeader'

import useSystemManagerNestedNavigation from '@hooks/useSystemManagerNestedNavigation'

import generateTabBarItems from '../../utils/generateTabBarItems'

const PageLayout = (props) => {
  const { activeTabBarItemKey, children, entityPayload } = props

  const {
    serviceProduct,
    urls: { serviceProductsIndexUrl },
  } = entityPayload

  const { redirect } = parsePermittedQueryParams(getQueryParamsFromHash(), ['redirect'])

  const { shouldUseNestedNavigation } = useSystemManagerNestedNavigation()

  return (
    <>
      <Helmet>
        <title>Service Products | Realhub</title>
      </Helmet>

      <PageHeader
        actionContent={(
          <Button
            as="a"
            buttonStyle="secondaryUtility"
            href={redirect || serviceProductsIndexUrl}
            size="medium"
            width="auto"
          >
            Back
          </Button>
        )}
        activeTabBarItemKey={activeTabBarItemKey}
        nestedNavigation={shouldUseNestedNavigation}
        tabBarItems={generateTabBarItems(serviceProduct)}
        title="Edit Product"
      />

      <Box paddingX="large" paddingTop={[112, 105]}>
        <Columns boxProps={{ marginTop: 'large' }} flexDirection={['column', 'column', 'row']}>
          {children}
        </Columns>
      </Box>
    </>
  )
}

PageLayout.propTypes = {
  activeTabBarItemKey: PropTypes.string,
  children: PropTypes.node.isRequired,
  entityPayload: PropTypes.shape({
    serviceProduct: PropTypes.object.isRequired,
    urls: PropTypes.shape({
      serviceProductsIndexUrl: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
}

export default PageLayout
